module.exports = __webpack_public_path__ + "static/media/pilot_sante_securite.c658a664.png";